module.exports = __webpack_public_path__ + "static/iett2-514a6f5894e8ded1f039221f8747d101.png";